import { tracker } from '../track';
export const trackSelectCalendarAlert = (element, campaignId) => {
    const selectContent = {
        element,
        promotion_id: campaignId,
    };
    tracker.track('GA4-select_calendar_alert', {
        event_name: 'select_calendar_alert',
        select_calendar_alert: selectContent,
    });
};
